import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { HistoriqueLogs, Produit } from '../../../../../common/src/entities';
import ChampFormulaire from '../../Common/ChampFormulaire';
import ChampMultipleFournisseur from '../Fournisseurs/ChampMultipleFournisseur';
import { DateTime } from 'luxon';
import FormulaireModificationEntite from '../Utils/FormulaireModificationEntite';
import { useFormikContext } from 'formik';
import ChampsAssocies from '../Utils/ChampsAssociés';
import PrixProduitTable from './HistoriquePrix/PrixProduitTable';
import { useGetQuery } from '../../../Utils/api';
import LogsLoader, { dateFormatter } from '../Utils/Log';
import { Tooltip } from '../../Common/Tooltip';
import { EtatEntite } from '../../Common/EtatEntite';
import CheckboxFormulaireEtatEntite from '../../Common/CheckboxFormulaireEtatEntite';
import { TitreCarte } from '../../Common/TitreCarte';
import { LABEL_COL } from '../constantes';
import { MyPaper } from '../Utils/MyPaper';
import ChampMultipleModelesHoraireGlissable from '../ModelesHoraire/ChampMultipleModelesHoraireGlissable';

export function ChampsProduit(): ReactElement {
    const {
        values: { fk_id_horaire_par_defaut, activiteProduits },
    } = useFormikContext<Produit>();
    const activite_combines = [
        ...(activiteProduits ?? []).map((a) => ({
            ...a,
            name: (
                <>
                    <b>{a.activite ? 'Produit de ' + a.activite.name : undefined}</b>
                </>
            ),
        })),
    ];
    const activite_combines_reformed = activite_combines.map(({ id, fk_id_activite, ...rest }) => ({
        id: fk_id_activite,
        ...rest,
    }));

    function EtatProduit(): JSX.Element {
        return (
            <EtatEntite>
                <CheckboxFormulaireEtatEntite id="actif" titre="Actif" />
            </EtatEntite>
        );
    }

    return (
        <div className="pb-5">
            {EtatProduit()}
            <MyPaper>
                <ChampFormulaire labelCol={LABEL_COL} id="name" titre="Nom" estPetit />
                <ChampMultipleFournisseur
                    id="fournisseur"
                    maxSize={1}
                    title="Fournisseur"
                    labelCol={LABEL_COL}
                    avecUnBouton
                />
                <ChampFormulaire id="description_produit" titre="Description" textarea labelCol={LABEL_COL} />
                <ChampFormulaire id="notes_internes" titre="Notes internes" textarea labelCol={LABEL_COL} />
                <ChampFormulaire
                    id="notes_fournisseur"
                    titre={
                        <>
                            Notes pour le fournisseur{' '}
                            <Tooltip tooltip="Visible pour le fournisseur dans les documents." id="tooltip-1" />
                        </>
                    }
                    textarea
                    labelCol={LABEL_COL}
                />
                <ChampFormulaire
                    id="notes_client"
                    titre={
                        <>
                            Notes pour le client{' '}
                            <Tooltip tooltip="Visible pour le client dans les documents." id="tooltip-2" />
                        </>
                    }
                    textarea
                    labelCol={LABEL_COL}
                />
                {/* <ChampFormulaire id="horaire" titre="Horaire" textarea labelCol={LABEL_COL} /> */}
                <ChampsAssocies
                    labelCol={LABEL_COL}
                    items={activite_combines_reformed}
                    url="activites"
                    titre="Activités associées"
                />
            </MyPaper>
            <MyPaper>
                <ChampMultipleModelesHoraireGlissable
                    labelCol={LABEL_COL}
                    id="modelesHorairesProduit"
                    horaireParDefautId={fk_id_horaire_par_defaut}
                />
            </MyPaper>
            <TitreCarte>
                <span>
                    Historique des prix{' '}
                    <small>
                        <small>
                            <i>Cette section est enregistrée automatiquement</i>
                        </small>
                    </small>
                </span>
            </TitreCarte>
            <PrixProduitTable />
        </div>
    );
}

export default function DetailsProduit(): ReactElement {
    const { id } = useParams() as { id: string };
    const listLogs = useGetQuery<HistoriqueLogs[]>(`historique_logs/${id}/produit`);
    return (
        <FormulaireModificationEntite
            id={+id}
            entite={Produit}
            badges={(p: Produit) => [
                `Produit #${p.id}`,
                `Créé : ${DateTime.fromISO(p.created_at).toRelativeCalendar()}`,
                `Dernière modification: ${
                    listLogs.data?.[listLogs.data.length - 1]?.date_modification
                        ? dateFormatter(listLogs.data?.[listLogs.data.length - 1]?.date_modification)
                        : 'Aucune modificiation'
                }  ${
                    listLogs.data?.[listLogs.data.length - 1]?.nom_usager
                        ? ' par ' + listLogs.data?.[listLogs.data.length - 1]?.nom_usager
                        : ''
                }`,
            ]}
            properties_to_reassign={{
                fournisseur: 'fk_id_fournisseur',
            }}
        >
            <ChampsProduit />
            <LogsLoader id={id} tableName={'produit'} />
        </FormulaireModificationEntite>
    );
}
